import styled from 'styled-components';

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.LIGHT1};
  width: 100%;
  z-index: 10000;
  height: auto;
  display: flex;
  flex-direction: column;
  transition: all 0.5s ease;

  box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
  border-left: 1px solid rgba(0, 0, 0, 0.2);

  button {
    background: none;
    transition: all 0.5s ease;

    &:hover {
      opacity: 0.5;
    }
  }

  header {
    display: flex;
    flex-direction: row;
    float: left;
    width: 100%;
    align-items: center;
    background: ${({ theme }) => theme.colors.LIGHT2};
    padding: 2rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);

    div {
      margin: 0 0px;
      flex: 1;
      float: left;
    }

    h1 {
      background: ${({ theme }) => theme.colors.TEXT1};
      font-size: 26px;
      font-weight: 700;
    }

    h2 {
      background: ${({ theme }) => theme.colors.TEXT1};
      font-weight: normal;
      font-size: 14px;
      opacity: 0.8;
    }
  }

  ul {
    list-style: none;
    float: left;
    width: 100%;
    background: ${({ theme }) => theme.colors.LIGHT2};
    padding: 20px;

    li {
      display: flex;
      flex-direction: row;
      float: left;
      width: 100%;
      list-style: none;
      border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
      border-radius: 4px;
      background: ${({ theme }) => theme.colors.LIGHT1};
      margin-bottom: 10px;
      display: flex;
      flex-direction: row;
      box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
      transition: all 0.5s ease;

      &:hover {
        background: ${({ theme }) => theme.colors.LIGHT1};
        text-decoration: underline;
      }

      p {
        padding: 20px;
        display: flex;
        font-size: 18px;
        flex: 1;
        color: ${({ theme }) => theme.colors.TEXT1};
        border-right: 2px solid rgba(0, 0, 0, 0.02);
        flex-direction: column;

        strong {
          font-size: 10px;
          margin: 0px;
          padding: 0px;
          background: ${({ theme }) => theme.colors.TEXT1};
        }

        small {
          font-size: 8px;
          background: ${({ theme }) => theme.colors.TEXT1};
        }
      }

      button {
        padding: 0 15px;
      }
    }
  }

  @media (max-width: 1024px) {
    width: 100%;
    height: 100%;
    overflow-y: auto;

    header {
      padding: 10px;

      > svg:first-child {
        display: none;
      }

      h1 {
        font-size: 16px;
      }
      h2 {
        font-size: 16px;
      }
    }

    ul {
      padding: 10px;

      li {
        padding: 5px;

        p {
          font-size: 12px;
        }
      }
    }
  }
`;
